import { Injectable } from '@angular/core';
import { PackingBoxViewApiService } from './view.service';

/**
 * Historical name kept for backwards compatibility with the routes wiring
 * (`{ provide: PackingBoxViewApiService, useClass: PackingBoxViewZebraApiService }`)
 * and downstream subclasses such as `CompoundingPackingBoxViewApiService`.
 *
 * The Zebra-only logic that used to live here has been merged into the base
 * `PackingBoxViewApiService` — that base IS the Zebra implementation now —
 * so this class no longer overrides anything.
 */
@Injectable()
export class PackingBoxViewZebraApiService extends PackingBoxViewApiService {}
